import { Theme } from "baseui/theme";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useWindowSize } from "./useWindowSize";

const useUnderBreakpoint = (breakpointName: keyof Theme["breakpoints"]) => {
  const [, theme] = useStyletron();
  const breakpoint = theme.breakpoints[breakpointName];
  const windowWidth = useWindowSize().width;
  const isUnder = windowWidth < breakpoint;
  return isUnder;
};

export { useUnderBreakpoint };
